<template>
  <div
    class="rounded-xl"
    :class="[
      activeTab
        ? 'shadow-primary'
        : mode === 'dark'
          ? 'border border-dark-border'
          : 'border border-border-10',
      mode === 'dark' ? 'bg-dark-sidebar' : 'bg-white-100',
    ]"
  >
    <div
      @click="setActiveTab"
      class="flex cursor-pointer items-center justify-between px-8 py-6 sm:p-4"
    >
      <span class="flex-1 text-[22px] font-semibold sm:text-[18px]">{{
        title
      }}</span>
      <span
        class="flex h-[48px] w-[48px] items-center justify-center rounded border sm:h-10 sm:w-10"
        :class="[mode === 'dark' ? 'border-dark-border' : 'border-border-10']"
      >
        <Minus v-if="activeTab" :size="20" :stroke-width="1.75" />
        <Plus v-else :size="20" :stroke-width="1.75" />
      </span>
    </div>
    <div
      v-if="activeTab"
      class="grid gap-6 border-t px-8 py-6 text-[14px] font-medium sm:gap-4 sm:p-4"
      :class="[mode === 'dark' ? 'border-dark-border' : 'border-border-10']"
    >
      <slot name="body" />
    </div>
  </div>
</template>

<script>
import { Minus, Plus } from "lucide-vue-next";

export default {
  name: "Collapsible",
  props: {
    mode: String,
    title: String,
  },
  components: {
    Plus,
    Minus,
  },
  data() {
    return {
      activeTab: false,
    };
  },
  methods: {
    setActiveTab() {
      this.activeTab = !this.activeTab;
    },
  },
};
</script>
